<template>
    <div>
        <!--今日结余-->
        <header class="form-title">
            <Row>
                <Col span="24">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="选择时间" style="margin-right: 200px">
                            <DatePicker
                                    split-panels
                                    type="daterange"
                                    :options="options"
                                    placeholder="选择日期"
                                    @on-change="modifyTime"
                                    :value="valuedate"
                            >
                            </DatePicker>
                        </FormItem>
                        <FormItem  label="总收入:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.sumPutMoney}}</strong>
                        </FormItem>
                        <FormItem  label="总支出:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.comeMoney}}</strong>
                        </FormItem>
                        <FormItem  label="结余:" style="margin-right: 30px">
                            <strong class="result">{{((dataTotl.sumPutMoney) - (dataTotl.comeMoney)).toFixed(2)}}</strong>
                        </FormItem>


                    </Form>
                </Col>
            </Row>
        </header>
         <ul class="bank">
             <li>
                 <Row class="cardBox" @click.native="detailPayList(1)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.xj}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.xjputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.xjcomemoney}}</Col>
                 </Row>
                 <h3>现金</h3>
             </li>
             <li>
                 <Row class="cardBox" style="background-color: #54a977;"  @click.native="detailPayList(4)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.wx}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.wxputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.wxcomemoney}}</Col>
                 </Row>
                 <h3>微信</h3>
             </li>
             <li>
                 <Row class="cardBox" style="background-color: #5e8cff;"  @click.native="detailPayList(3)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.zfb}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.zfbputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.zfbcomemoney}}</Col>
                 </Row>
                 <h3>支付宝</h3>
             </li>
             <li>
                 <Row class="cardBox" style="background-color: #ff8080;"  @click.native="detailPayList(2)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.yhk}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.yhkputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.yhkcomemoney}}</Col>
                 </Row>
                 <h3>银行卡</h3>
             </li>
             <li>
                 <Row class="cardBox"  style="background-color: #809dff;"  @click.native="detailPayList(6)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.hyk}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.hykputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.hykcomemoney}}</Col>
                 </Row>
                 <h3>会员卡</h3>
             </li>
             <li>
                 <Row class="cardBox"  style="background-color: #5d56bc;"  @click.native="detailPayList(5)">
                     <Col span="24" class="jieyu">
                         结余<h1>{{dataTotl.m.qt}}</h1>
                     </Col>
                     <Col span="12" class="sz">收入：{{dataTotl.m.qtputmoney}}</Col>
                     <Col span="12" class="sz">支出：{{dataTotl.m.qtcomemoney}}</Col>
                 </Row>
                 <h3>其他</h3>
             </li>
         </ul>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cid:'',
                sid:'',
                options: {
                    shortcuts: [
                        {
                            text: '昨日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                                return [start, start];
                            },
                        },
                        {
                            text: '今日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                return [start, end];
                            },
                        },
                        {
                            text: '近七日',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        }
                    ],
                },
                data: [],
                dataTotl:{},
                loadingTable:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.valuedate[0] = this.fun_date(0)
            this.valuedate[1] = this.nowTime
            this.getToday(this.valuedate[0],this.valuedate[1])
        },

        methods: {
            //获取列表
            getToday(startTime,endTime){
                this.$Api.getToday({
                    cid: this.cid,
                    sid: this.sid,
                    type:'',
                    tradetypeid:'',
                    beantime: startTime,
                    etime:endTime,
                }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.dataTotl = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            modifyTime(data){
                this.valuedate[0] = data[0]
                this.valuedate[1] = data[1]
                this.getToday(this.valuedate[0],this.valuedate[1])
            },
            detailPayList(id){
                this.$router.push({
                    path:'/consumption',
                    query:{
                        id:id
                    }
                })
            }
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
.bank{
    li{
        margin-left: 70px;
        margin-top: 30px;
        display: inline-block;
        text-align: center;

        .cardBox{
            cursor: pointer;
            width: 360px;
            background: #ffb366;
            color: #ffffff;
            box-shadow: 0px 3px 10px 0px
            rgba(24, 54, 129, 0.14);
            border-radius: 10px;
            font-size: 16px;
            margin-bottom: 20px;
            .jieyu{
                padding: 15px 0 0;
                h1{
                    font-size: 50px;
                }
            }
            .sz{
                padding:0 0 20px;
            }
        }
    }
}

</style>